<div class="loading-spinner" [style.width]="width" [style.height]="height">
  <svg class="small" [attr.viewBox]="viewBox" [style.width]="width" [style.height]="height">
    <circle class="blue-dot small" />
    <circle class="grey-dot small" />
    <circle class="orange-dot small" />
  </svg>
</div>
